module.exports = __webpack_public_path__ + "static/media/nbaa.7211384c.png";